import { useFormatMyCustomersLink } from './useMyCustomersLink';
import { useOrganisationPersonalWebshop } from './useOrganisationPersonalWebshop';

export const useNavigation = () => {
    const { rootUrl, baseUrl, organisationPersonalWebshopSlug } = useOrganisationPersonalWebshop();
    const { formatLink } = useFormatMyCustomersLink();

    const prependBase = (path: string) => `${baseUrl}${path}`;

    const prependRoot = (path: string) => `${rootUrl}${path}`;

    // Keep the /sv prefix for Finland-Swedish (sefi) consultants; formatLink is a
    // no-op on other markets and when the url already carries the prefix.
    const myCustomersUrl = (path: string) => {
        const url = `${rootUrl}/my-customers/${path}`.replace(/\/$/, '');

        return url.startsWith('/sv') ? url : formatLink(url);
    };

    const myAccountUrl = (path: string) => `${rootUrl}/my-account/${path}`.replace(/\/$/, '');

    return {
        shop: {
            home: baseUrl,
            checkout: prependBase('/checkout'),
            success: prependBase('/success'),
            favourites: prependBase('/favourites'),
            findconsultant: prependBase('/findconsultant'),
            search: (searchString: string) => prependBase(`/catalogsearch/result/${searchString}`),
            product: (slug: string = '') => prependBase(`/product/${slug}`), // Need trim?
            consultantProfile: prependRoot(`/consultant/${organisationPersonalWebshopSlug}/profile`),
        },

        myCustomers: {
            home: myCustomersUrl('').replace(/\/$/, ''),
            settings: myCustomersUrl('/settings'),
        },

        myAccount: {
            tab: (tabName: string) => myAccountUrl(tabName),
            settings: myAccountUrl(''),
        },

        system: {
            userLoginCallback: (callbackUrl: string) => `/user/login?callbackUrl=${callbackUrl}`,
            // No longer used,thats why its put in system.
            userRegister: '/user/register',
        },
    };
};
